import React, { useState } from 'react';
import BrakeshoeDesign from './BrakeshoeDesign';
import EnergyManagement from './EnergyManagement';
import MachineStatus from './MachineStatus';
import OEE from './OeeComp';
import NavigationButtons from '../NavigationButtons/NavigationButtons';


const Process = () => {
    const [activeTab, setActiveTab] = useState('design');

    return (
        <div className='h-screen w-full'>
            <div className="header">PROCESS DESIGN UNIT</div>

            <div className='flex flex-col bg-gray-200 lg:flex-row'>
                <div className='flex bg-gray-200 justify-center w-[97%] items-center'>
                    <NavigationButtons />
                </div>
                <div className="flex flex-wrap bg-gray-200 justify-center p-4 actives_buttons gap-4 lg:justify-end">
                    <button className="btns transparent" onClick={() => setActiveTab('design')}>BRAKESHOE DESIGN</button>
                    <button className="btns transparent" onClick={() => setActiveTab('energy')}>ENERGY MANAGEMENT</button>
                    <button className="btns transparent" onClick={() => setActiveTab('mstatus')}>MACHINE STATUS</button>
                    <button className="btns transparent" onClick={() => setActiveTab('oee')}>OEE</button>
                </div>
            </div>


            {activeTab === 'design' && (
                <div className="tab-content">
                    <BrakeshoeDesign />
                </div>
            )}

            {activeTab === 'energy' && (
                <div className="tab-content">
                    <EnergyManagement />
                </div>
            )}

            {activeTab === 'mstatus' && (
                <div className="tab-content">
                    <MachineStatus />
                </div>
            )}

            {activeTab === 'oee' && (
                <div className="tab-content">
                    <OEE />
                </div>
            )}

            <div className="flex bg-[#141622] h-[70px] justify-center text-center text-sm text-white w-full items-center lg:text-xl md:text-lg sm:text-base">
                <p>

                    Central Manufacturing Technology Institute, Tumkur Road,
                    Bengaluru-560022, Karnataka, India © 2024 CMTI All rights reserved. ||
                    <a href="https://example.com" className="hover:underline mx-2">
                        Terms and Conditions
                    </a>
                </p>
            </div>
        </div>
    );
}

export default Process;